import React from "react";
import { Card, GridLegacy } from "@mui/material";
import CardBody from "../../../../components/Card/CardBody";
import MenuSyncSettings from "../MenuSyncSettings";
import FormSwitchTC from "../../../../components/Forms/FormSwitchTC";
import FormTextTC from "../../../../components/Forms/FormTextTC";
import AutoImagesSyncSwitch from "./PosSyncs/AutoImagesSyncSwitch";

function Tweakwise() {
  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
            <FormSwitchTC
              name={"apiaccounts__useTest"}
              tDefault={"Gebruik test omgeving"}
              tKey={"vestigingen.form.apiaccounts.label.useTest"}
            />
            <FormTextTC
              name={"apiaccounts__tweakwiseStoreCode"}
              tDefault={"Tweakwise storeCode"}
              tKey={"vestigingen.form.tweakwise.label.tweakwiseStoreCode"}
            />
            {/*<FormTextTC*/}
            {/*  name={"apiaccounts__tweakwiseAccessToken"}*/}
            {/*  tKey={"vestigingen.form.tweakwise.label.tweakwiseAccessToken"}*/}
            {/*  tDefault={"Tweakwise Access Token"}*/}
            {/*/>*/}
          </GridLegacy>

          <MenuSyncSettings />

          <AutoImagesSyncSwitch />
        </CardBody>
      </Card>
    </div>
  );
}

export default Tweakwise;
